<template>
  <v-layout bg-quadrinhos termos>
    <v-content>
      <v-container white--text>
        <index-header :title="$t('text.termsOfUse')"></index-header>
        <v-layout justify-center mb-5>
          <v-flex md8 xs12>
            <v-progress-circular
              :size='30'
              indeterminate
              color='primary'
              v-if='loaded == false'
              class='center'
            ></v-progress-circular>
            <div class='termos-text'>
              <div v-html='text'></div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-layout>
</template>

<script>
import axios from 'axios';
import indexHeader from '@/components/indexHeader';
import indexFooter from '@/components/indexFooter';
import bus from '@/utils/bus';

export default {
  name: 'Termos',
  components: {
    'index-footer': indexFooter,
    'index-header': indexHeader
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      errors: [],
      loaded: false,
      flag: this.$cookies.get('isoCode'),
      text: ''
    };
  },
  mounted() {
    this.getTermsofservice();
  },
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
    es() {
      return this.lang === 'es' || this.lang === 'es_EC';
    },
    pt() {
      return this.lang === 'pt' || this.lang === 'pt_BR';
    }
  },
  methods: {
    async getTermsofservice() {
      let flag = this.flag;

      await axios
        .get(`/api/termsofservice/${flag}/web`)
        .then(response => {
          this.text = response.data;
          this.loaded = true;
          bus.$emit('loading', false);
          bus.$emit('StickySidebarPerfil');
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          this.errors.push(e);
          this.loaded = true;
        });
    }
  }
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.termos {
  &-text {
    & > h1,
    & > p.ql-align-justify:first-child {
      display: none;
    }

    p {
      font-weight: lighter;
    }

    h3 {
      margin-bottom: 20px;
    }
  }
}
</style>
